'use client';

import { createContext } from 'react';

import type { ModalRootContextInterface } from '../types/modal-root.types';

export const ModalRootContext = createContext({} as ModalRootContextInterface);

ModalRootContext.displayName = 'Modal.Root.Context';
